import './Projects.sass';
import SectionHeading from '../../Components/SectionHeading/SectionHeading.js';
import FadeIn from '../../Components/Motion/FadeIn.js';
import { ArrowUpRightIcon } from '../../Components/Icons/Icons.js';

function ShowProjects() {
  const projects = [
    {
      name: 'AdServe — Real-Time Ad Serving & Auction Platform',
      description: 'July 2026 - Sep 2026',
      technologies: 'Python, FastAPI, PostgreSQL, SQLAlchemy, Redis, Kafka, Docker, Locust',
      content: [
        'Engineered a real-time ad auction platform modeling 2M users, 5K advertisers, and ∼23K campaigns, supporting audience targeting, weighted ranking, budget enforcement, and impression/click/conversion tracking.',
        'Optimized the auction hot path by eliminating SQLAlchemy N+1 queries, reducing request latency ∼9× (1.75s → 0.15–0.28s); root-caused a Redis cache stampede under concurrent load and redesigned caching with stale-while-revalidate, cutting median latency 3.1s → 94ms (∼33×) and increasing throughput 2.8× over the uncached baseline',
        'Scaled the FastAPI service with multi-process workers, connection-pool tuning, and concurrency profiling to ∼770 RPS with 300ms p95 latency and 0% failures at 150 concurrent users, while sustaining 1.1K+ RPS with 0% failures in stress tests up to 1,600 concurrent users.',
        'Eliminated a concurrent lost-update race that silently dropped 90% of campaign charges by implementing atomic PostgreSQL updates; reduced the write path from 7 to 3 SQL statements (∼57% fewer round trips).',
        'Built an idempotent Kafka event pipeline with at-least-once delivery for click/conversion processing and user-preference learning; integrated learned interest weights into auction ranking, producing a measured ∼26% relative increase in wins for ads matching users’ most-engaged interests.',
      ],
    },
    {
      name: 'Machine Learning: Human Emotion Detector',
      description: 'Jan 2024 - April 2024',
      technologies: 'Python, Jupyter Notebook, Pandas, Keras, Tensorflow, Scikit-Learn',
      content: [
        'Trained various machine learning and deep learning models, including SVM, ANN, and CNN, to predict human emotions from grayscale images, achieving accurate emotion classification through image analysis.',
        'Preprocessed a dataset of 37,000+ human emotion images taken from Kaggle, utilized Pandas, Keras, and NumPy to optimize them as training data for machine learning models, achieving an average prediction accuracy of 60%.',
      ],
    },
    {
      name: 'Spotify Wrapped',
      description: 'June 2023 - In Progress',
      technologies: 'REST API, Python, Flask, JSON, OAuth, React.js',
      content: [
        'Creating a web application emulating Spotify\'s \'Spotify Wrapped\' feature, providing users with personalized Spotify metrics based on their music preferences and listening habits',
        'Enables users to access their custom Spotify metrics at any time, offering a unique and engaging experience.',
      ],
    },
    {
      name: 'Metrics Automation',
      description: 'June 2023 - August 2023',
      technologies: 'REST API, Git, Python, NumPy, Pandas',
      content: [
        'Collaborated with stakeholders, product owners, and my team of engineers to automate metric generation in Python, which resulted in a 90% reduction in manual workload for metrics collection across all projects and teams.',
        'Spearheaded the development of our backend data pipeline by designing, implementing, and testing the code base, which provided half the metrics for our automation platform.',
      ],
    },
    {
      name: 'ChatGPT-Powered Monkey Bot',
      description: 'December 2022 - August 2023',
      technologies: 'REST API, Python',
      content: [
        'Crafted a fun and interactive Discord bot to help moderate and entertain server members.',
        'The bot helped to actively monitor server chats, apply temporary chat and voice chat restrictions to rule violators, and used API calls to provide entertaining ChatGPT-powered responses',
      ],
    },
    {
      name: 'Hospital Management System',
      description: 'January 2023 – May 2023',
      technologies: 'Java, HTML, CSS, Bootstrap, MySQL',
      link: 'https://github.com/bryan-bee/Hospital-Management',
      content: [
        'Engineered a web application designed to provide hospitals with an intuitive interface for viewing and editing patient and vaccine information.',
        'The service offered user-friendly patient and vaccine data management for healthcare providers',
      ],
    },
  ];

  return (
    <div className="projects_items">
      {projects.map((i, idx) => (
        <FadeIn key={i.name} delay={Math.min((idx % 2) * 0.1, 0.3)} className="projects_items_card">
          <div className="projects_items_card_top">
            {i.link ? (
              <a href={i.link} target="_blank" rel="noopener noreferrer" className="projects_items_card_link fs2">
                <b>{i.name}</b> <ArrowUpRightIcon />
              </a>
            ) : (
              <div className="projects_items_card_link fs2"><b>{i.name}</b></div>
            )}
            <div className="projects_items_card_description fs1">{i.description}</div>
          </div>

          <ul className="projects_items_card_list">
            {i.content.map((j) => (
              <li className="projects_items_card_maintext bullet fs1" key={j}>{j}</li>
            ))}
          </ul>

          <div className="projects_items_card_tech">
            {i.technologies.split(',').map((tech) => (
              <span className="tech_pill fs1" key={tech}>{tech.trim()}</span>
            ))}
          </div>
        </FadeIn>
      ))}
    </div>
  );
}

function Projects() {
  return (
    <div className="projects_main" id="projects">
      <div className="projects">
        <SectionHeading eyebrow="Projects" text="Technical Projects" />
        <ShowProjects />
      </div>
    </div>
  );
}

export default Projects;
